//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AccountNavigation",
  props: {
    currentPage: {
      type: String,
      required: true
    }
  },
  computed: {
    pages() {
      return [{
        label: this.$t("settings.accountTab.tabs.profile"),
        key: "profile"
      }, {
        label: this.$t("settings.accountTab.tabs.personalDetails"),
        key: "personal-details"
      }, {
        label: this.$t("settings.accountTab.tabs.emailPreferences"),
        key: "email-preferences"
      }, {
        label: this.$t("settings.accountTab.tabs.lenderSubmissionDetails"),
        key: "filogix-details"
      }, {
        label: this.$t("settings.accountTab.tabs.applicationRecurringReminders"),
        key: "recurring-reminders"
      }];
    }
  },
  methods: {
    handlePageChange(key) {
      this.$emit("page-change", key);
    }
  }
});